import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Shared chats are now Multichats",
  published_at: "2026-05-28",
  summary: "Collaborate with your team in the same chat, at the same time!",
  tags: ["Platform", "AI"],
  draft: false
};
export const sections = [{
  id: "more-chat-improvements",
  label: "More chat improvements"
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Until now, sharing a chat let teammates read along — but only you could talk to Sweetspot AI. Now everyone in a shared chat can join in, so your whole team works the same opportunity in one thread, with Sweetspot AI right there alongside you."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "0b2d50bc-0aad-4fcb-9f2a-1062a9ac3ff3",
      aspectRatio: "1424 / 1080",
      className: "bg-white",
      frameClassName: "bg-white",
      edgeMaskClassName: "ring-2 ring-inset ring-white"
    }), "\n", _jsx(_components.p, {
      children: "Watch teammates join in real time, and put Sweetspot AI to work whenever you need it — ask a question or hand off a task, and everyone sees the answer. The whole conversation stays tied to the opportunity instead of scattered across Teams and email."
    }), "\n", _jsx(_components.h2, {
      id: "more-chat-improvements",
      tabIndex: "-1",
      children: "More chat improvements"
    }), "\n", _jsx(_components.p, {
      children: "We're also continually improving chats. For one, you can now stop a response mid-stream — press stop and you keep everything Sweetspot AI has already written."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "616453b6-dfe0-4a28-95cc-5971d1212a23",
      aspectRatio: "1396 / 1080",
      className: "bg-white",
      frameClassName: "bg-white",
      edgeMaskClassName: "ring-2 ring-inset ring-white"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
